import {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {IsAuthnticated} from "../tools/AuthCheck";
import {CurrentUser} from "../Hooks/currentUser";

export const AuthProvider = ({routeName, children, level}) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {

        switch (level) {
            case "auth":
            case "public":
            case "form":
                break;
            case "sign":
                if (IsAuthnticated()) {
                    if (CurrentUser().Role === "Student") {
                        navigate("/studentlanding  ", {replace: true});

                    } else {
                        navigate("/information  ", {replace: true});
                        
                    }
                }
                break;
            default:
                break;
        }
        if (routeName !== "notfound" && level !== "public" && level !== "sign" && !IsAuthnticated()) {
            navigate("/login", {replace: true});
        }

    }, [location.pathname]);
    return children;
};
